import React, { useState } from 'react'
import InitialStep from './steps/InitialStep'
import SuccessStep from './steps/SuccessStep'
import { SurveySteps } from './types'

const posthogCloseAction = 'Gap filler runaway - closed'

const SurveyScreen = () => {
  const [currentStep, setCurrentStep] = useState<SurveySteps>(SurveySteps.INITIAL)

  const moveToNextStep = () => {
    setCurrentStep(SurveySteps.SUCCESS)
  }

  const renderStep = () => {
    switch (currentStep) {
      case SurveySteps.INITIAL:
        return <InitialStep onNext={moveToNextStep} postHogAction={posthogCloseAction} />
      case SurveySteps.SUCCESS:
        return <SuccessStep />
      default:
        return null
    }
  }

  return renderStep()
}

export default SurveyScreen
